/*eslint-disable */
const $ = window.jQuery = require('jquery');
import axios from 'axios';
import countries from '@/services/country.json'
import userConnectedPopup from '@/components/user-connected-request-popup/index.vue';
import {
  mapGetters
} from 'vuex';
import {
  bus
} from '@/main';
export default {
  name: 'user-details',
  components: {
    userConnectedPopup
  },
  props: [],
  data() {
    return {
      userDetails:null,
      loadmoreData: {},
      userLoading: false,
      nextStep: '',
      selfUserDetails:null,
      bioFullData: '',
      bioFullDataPopup: false,
      blogListState: {},
      blogListResults: [],
      publicBlogListState: {},
      publicBlogListResults: [],
      selfUserId: '',
      pubBlogState: true,
      is_guestuser: false,
      is_superuser: false,
      blogActv: true,
      profileUpdateAlertPopup: false,
      userProfileDetails:null,
      userProfileAvatar:true,
      countryList:[],
      getAboutInfo:null,
      userConnectedRequestState:false,
      getUserOnlineTimeInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters',
      'getAboutDetailsOfMemberUserGetters',
      'getUserOnlineTimeCountGetters'
    ]),
    getSelfUserDetailsAgainFun() {
      this.selfUserDetails = this.$store.getters.acUserDetailsStateGetters.data
      return
    },
    SetIntialSuperUserStatus() {
      if (this.selfUserDetails) {
        this.is_superuser = this.selfUserDetails.is_superuser
        this.is_guestuser = this.selfUserDetails.guest
      }
      return
    },
    getAboutInfoFun(){
      this.getAboutInfo = this.$store.getters.getAboutDetailsOfMemberUserGetters.data
      return
    },
    getUserOnlineTimeInfoFun(){
      this.getUserOnlineTimeInfo = this.$store.getters.getUserOnlineTimeCountGetters.data
      return
    }
  },
  mounted() {
    if (localStorage.getItem('LoginedUserID')) {
      this.selfUserId = localStorage.getItem('LoginedUserID')
    }
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getSelfUserDetailsAgainFun
    this.SetIntialSuperUserStatus
    this.getAboutInfoFun
    this.getUserOnlineTimeInfoFun
    this.getUserDetailsAgainFun()
    this.getPubBlogListFun()
    bus.$on('userConnectedRequestStateBus', (data) => {
      this.userConnectedRequestState = data
    })
  },
  methods: {
    secondsToHms(d) {
        d = Number(d);
        var h = Math.floor(d / 3600);
        var m = Math.floor(d % 3600 / 60);
        var s = Math.floor(d % 3600 % 60);

        var hDisplay = h > 0 ? h + (h == 1 ? " Hour, " : " Hours, ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? " Min, " : " Mins, ") : "";
        var mODisplay = m > 0 ? m + (m == 1 ? " Min " : " Mins ") : "";
        var sDisplay = s > 0 ? s + (s == 1 ? " Sec" : " Secs") : "";
      if(hDisplay){
        return hDisplay + mODisplay; 
      }else{
        return mDisplay + sDisplay; 
      }
    },
    openChatRequestPopupMethod(){
      this.userConnectedRequestState = true
      $('body').addClass('notConnectedUserBody')
    },
    getUserDetailsAgainFun() {
      this.$store.dispatch('getMemberUserDetailsFun',{id:this.$route.params.userDetailsId}).then((res)=>{
        this.userDetails = res.data.data
        this.userProfileDetails = this.userDetails.profile
        if(this.userProfileDetails.thumbnail === null){
          this.userProfileAvatar = false
        }
      })
    },
    getPubBlogListFun() {
      if(this.is_superuser){
        this.$store.dispatch('getBlogListForSuperUserAction',{id:this.$route.params.userDetailsId}).then((res)=>{
          this.publicBlogListState = res.data.data
          if (this.publicBlogListState != undefined) {
            this.publicBlogListResults = this.publicBlogListState.results
          }
        })
      }else{
        this.$store.dispatch('getPublicBlogListAction').then((res)=>{
          this.publicBlogListState = res.data.data
          if (this.publicBlogListState != undefined) {
            this.publicBlogListResults = this.publicBlogListState.results
          }
        })
      }
    },
    userInfoAlertPopupOpenFun() {
      $('body').addClass('body_right_scroll_remove')
      this.profileUpdateAlertPopup = true
    },
    userInfoAlertPopupClosedFun() {
      $('body').removeClass('body_right_scroll_remove')
      this.profileUpdateAlertPopup = false
    },
    homeFilterFun(checkItem, param) {
      $('.total_count_box').removeClass('active')
      $('#homeFilterTab' + param).addClass('active')
      if (checkItem === 'blog') {
        this.blogActv = true
      } else {
        this.blogActv = false
      }
    },
    OnlyShowMyBLogsFun() {
      if (this.pubBlogState === true) {
        this.pubBlogState = false
      } else {
        this.pubBlogState = true
      }
    },
    bioReadMoreFun(data) {
      this.bioFullData = data
      this.bioFullDataPopup = true
      $('body').addClass('body_right_scroll_remove')
      var __self = this
      $(document).click(function (event) {
        //if you click on anything except the modal itself or the "open modal" link, close the modal
        if (!$(event.target).closest(".bio_text_read_more,.bio_more_data_popup_modal").length) {
          __self.bioFullData = ''
          __self.bioFullDataPopup = false
          $('body').removeClass('body_right_scroll_remove')
        }
      });
    },
    hideBioDataPopup() {
      this.bioFullData = ''
      this.bioFullDataPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    getCountryName(countryCode) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        country = country.name
      } else {
        country = ''
      }
      return country;
    },
  },
  watch: {
    getSelfUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters
    },
    SetIntialSuperUserStatus() {
      if (this.selfUserDetails) {
        this.is_superuser = this.selfUserDetails.is_superuser
        this.is_guestuser = this.selfUserDetails.guest
      }
      return
    },
    getAboutInfoFun(){
      return this.$store.getters.getAboutDetailsOfMemberUserGetters
    },
    getUserOnlineTimeInfoFun(){
      return this.$store.getters.getUserOnlineTimeCountGetters
    }
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('body_right_scroll_remove')
    next();
  },
}